let html2Escape = (strText) => {
	return strText.replace(/[<>&"]/g, function(c) {
		return {
			'<': '&lt;',
			'>': '&gt;',
			'&': '&amp;',
			'"': '&quot;'
		} [c];
	});
}

/**
 * 净化 HTML 内容，移除危险标签和属性（防止 XSS 攻击）
 * @param {string} html 原始 HTML 内容
 * @returns {string} 净化后的 HTML
 */
let sanitizeHtml = (html) => {
	if (!html) return '';
	// 移除 script 标签及其内容
	let sanitized = html.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
	// 移除 style 标签及其内容
	sanitized = sanitized.replace(/<style\b[^<]*(?:(?!<\/style>)<[^<]*)*<\/style>/gi, '');
	// 移除 iframe 标签
	sanitized = sanitized.replace(/<iframe\b[^>]*>.*?<\/iframe>/gi, '');
	// 移除 object/embed/applet 标签
	sanitized = sanitized.replace(/<(object|embed|applet)\b[^>]*>.*?<\/\1>/gi, '');
	// 移除所有 on* 事件属性（如 onclick, onerror 等）
	sanitized = sanitized.replace(/\s+on\w+\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '');
	// 移除 javascript: 协议
	sanitized = sanitized.replace(/javascript\s*:/gi, '');
	// 移除 data: 协议（用于 src/href 属性中的恶意内容）
	sanitized = sanitized.replace(/(src|href)\s*=\s*["']?\s*data\s*:/gi, '$1="');
	return sanitized;
}

export default {
	html2Escape,
	sanitizeHtml
}